module.exports = __webpack_public_path__ + "img/gesso.41bd8752.png";